import { render, staticRenderFns } from "./SepticSubmissionForm.vue?vue&type=template&id=565c1a62"
import script from "./SepticSubmissionForm.vue?vue&type=script&lang=js"
export * from "./SepticSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports